import { SVGProps } from 'react'

const SvgUp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' {...props}>
    <path d='M128 320l128-128 128 128z' />
  </svg>
)

export default SvgUp
